import { Component } from '@angular/core';

@Component({
  selector: 'app-pdf-excel-content',
  imports: [],
  templateUrl: './pdf-excel-content.component.html',
  styleUrl: './pdf-excel-content.component.css'
})
export class PdfExcelContentComponent {

}
